export default __webpack_public_path__ + "static/media/slot5.189a0c39.png";